import { useAuth } from "@/contexts/AuthContext";
import { FlaskConical } from "lucide-react";

/**
 * Persistent labelling banner for synthetic contest demo sessions.
 * Rendered only when the authenticated user has is_demo=true.
 * NEVER shown for real students or admins.
 */
export function DemoBanner() {
  const { user } = useAuth();
  if (!user || user === false || !user.is_demo) return null;
  return (
    <div
      role="status"
      data-testid="demo-banner"
      className="w-full bg-[#FEF3C7] border-b border-[#F59E0B]/40 text-[#78350F]"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-2 flex items-center gap-2 text-xs sm:text-sm">
        <FlaskConical className="w-4 h-4 shrink-0 text-[#B45309]" />
        <span className="font-semibold">Sentetik demo</span>
        <span className="text-[#92400E]">·</span>
        <span className="text-[#92400E]">
          Gerçek öğrenci verisi değildir. İzole, tek kullanımlık bir tanıtım oturumudur.
        </span>
      </div>
    </div>
  );
}

export default DemoBanner;
